<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
<!--        <el-col :span="16">-->
<!--          <span class="base-name">{{detail.informantName}}</span>-->
<!--        </el-col>-->
        <el-col :offset="18" :span="6" align="right">
          <el-button type="text" v-if="detail.canOperateFlag && detail.clueStatus === 'follow_up'" @click="handleAssign()">分配</el-button>
          <el-button type="text" v-if="detail.canOperateFlag && detail.clueStatus === 'follow_up'" @click="handleClueToBusiness()">转商机</el-button>
          <el-button type="text" v-if="detail.canOperateFlag && detail.clueStatus === 'follow_up'" @click="handleCloseClue()">关闭</el-button>
          <el-button type="text" v-if="detail.canOperateFlag && detail.clueStatus === 'closed'" @click="handleOpenClue()">恢复</el-button>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">公司名称</div>
          <div class="value">{{detail.customerName}}</div>
        </div>
        <div class="base-item">
          <div class="title label">线索来源</div>
          <div class="value">{{detail.clueSourceDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">线索状态</div>
          <div class="value">{{detail.displayStatusDesc || detail.clueStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">最新跟进时间</div>
          <div class="value">{{detail.followUpDate}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" type="card" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd v-if="detail.canOperateFlag && detail.clueStatus === 'follow_up'" :targetId="detail.id" targetType="clue" @success="handleAfterFollowAdd"></FollowAdd>
                  <div :style="{height: detail.canOperateFlag && detail.clueStatus === 'follow_up' ? '473px': '609px'}">
                    <FollowList :targetId="detail.id" targetType="clue" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="clue" :managerId="detail.managerId" :clueStatus="detail.canOperateFlag ? detail.clueStatus : 'approval_locked'" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel && detail.canEditFlag">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="85px" :hide-required-asterisk="!editModel">
                <el-row :gutter="20" align="left">
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="客户名称:" prop="customerId">
                      <customer-select v-if="editModel" ref="customerSelectRef" :form-param="updateData" :param-list="customerList" @change="customerChange"></customer-select>
                      <el-button v-else type="text" @click="skipCustomerDetail(detail.customerId)">{{detail.customerName}}</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="联系人:" prop="contactId">
                      <el-select v-if="editModel" v-model="updateData.contactId" placeholder="请选择联系人" clearable style="width:100%">
                        <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
                      </el-select>
                      <el-button v-else type="text" @click="skipContactDetail(detail.contactId)">{{detail.contactName}}</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="editModel && detail.canEditFlag && !detail.canOperateFlag">
                    <el-form-item label="负责人:" prop="assignUserId">
                      <UserSelect v-model="updateData.assignUserId" placeholder="请选择线索负责人"></UserSelect>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="手机号:" prop="contactMobile">
                      <el-button type="text" title="点击获取完整手机号" v-if="detail.contactMobile.indexOf('**')>=0"
                                 @click="queryMobile">{{ detail.contactMobile }}</el-button>
                      <span v-else>{{ detail.contactMobile }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="线索来源:" prop="clueSource">
                      <el-select v-if="editModel" v-model="updateData.clueSource" placeholder="请选择线索来源" allow-create filterable clearable style="width:100%">
                        <el-option v-for="dict in sourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                      </el-select>
                      <span v-else class="value">{{detail.clueSourceDesc}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12">
                    <el-form-item label="采购需求:" prop="purchaseIntentionList">
                      <el-select v-if="editModel" v-model="updateData.purchaseIntentionList" placeholder="请选择采购需求" multiple clearable style="width:100%">
                        <el-option v-for="dict in purchaseIntentionOptions" :key="dict.value" :label="dict.label" :value="dict.value"/>
                      </el-select>
                      <span v-else class="value">{{detail.purchaseIntentionDesc}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建人:">
                      <span class="value">{{detail.createByUserName}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                    <el-form-item label="创建时间:">
                      <span class="value">{{detail.createTime}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="备注:" prop="remark">
                      <el-input
                        v-if="editModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateData.remark"
                        placeholder="请输入备注"
                        clearable/>
                      <ClueRemark v-else :remark="detail.remark" :source="detail.clueSourceDesc || detail.clueSource" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.managerAvatar" :name="detail.managerName"/>
            <div class="name"><span class="value">{{detail.managerName}}</span></div>
          </div>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="clue"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
    <ClueToBusinessDialog ref="clueToBusinessDialogRef" @success="refreshDetailAndLog"></ClueToBusinessDialog>
    <CloseClueDialog ref="closeClueDialogRef" @success="refreshDetailAndLog"></CloseClueDialog>
    <OpenClueDialog ref="openClueDialogRef" @success="refreshDetailAndLog"></OpenClueDialog>
  </div>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import ClueRemark from './ClueRemark.vue';
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import CompanyInfoButton from "@/views/crm/components/companyInfoButton";
import CompanyInput from "@/views/crm/components/companyInput";
import AssignDialog from "@/views/crm/components/assignDialog";
import ClueToBusinessDialog from "@/views/crm/clue/clueToBusinessDialog";
import CloseClueDialog from "@/views/crm/clue/closeClueDialog";
import OpenClueDialog from "@/views/crm/clue/openClueDialog";
import {checkCluePhoneNum, queryClueDetail, updateClue} from "@/api/crm/clue";
import {isPhone} from "@/utils/validate";
import UserAvatar from '@/views/system/user/userAvatar'
import {queryContactByCustomerId, queryMobile} from "@/api/crm/contact";
import {queryProductTypeList2} from "@/api/crm/contract";
import customerSelect from "@/views/crm/components/customerSelect";

export default {
  name: "ClueDetail",
  data() {
    return {
      // 遮罩层
      loading: true,
      detail: {},
      openEditOnLoad: this.$route.query.edit === '1',
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      // 线索来源字典
      sourceOptions: [],
      customerList: [],
      contactList: [],
      purchaseIntentionOptions: [],
      updateData: {
        id: null,
        clueSource: null,
        contactId: null,
        customerId: null,
        assignUserId: null,
        purchaseIntentionList: [],
        remark: null
      },
      updateRules: {
        clueSource: [
          {required: true, message: '请选择线索来源', trigger: 'change'}
        ],
        customerId: [
          {required: true, message: '请选择客户姓名', trigger: 'change'}
        ],
        contactId: [
          {required: true, message: '请选择联系人', trigger: 'change'}
        ],
        assignUserId: [
          {required: true, type: 'number', message: '请选择线索负责人', trigger: 'change'}
        ],
        purchaseIntentionList: [
          {required: true, message: '请选择采购需求', trigger: 'change'}
        ],
        remark: [
          {max: 1000, message: '备注最长1000个字符', trigger: 'change'}
        ]
      },
    };
  },
  components: {
    ClueRemark,
    UserSelect,
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    CompanyInfoButton,
    CompanyInput,
    AssignDialog,
    CloseClueDialog,
    OpenClueDialog,
    ClueToBusinessDialog,
    UserAvatar,
    customerSelect
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的线索");
    }
    this.getDicts("common_source").then(response => {
      this.sourceOptions = response.data;
    });
    queryProductTypeList2({}).then(response => {
      this.purchaseIntentionOptions = response.data || [];
    })
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (name) {
      console.log("tab: " + name)
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryClueDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
          if (this.openEditOnLoad && this.detail.canEditFlag) {
            this.openEditOnLoad = false
            this.activeName = 'detail'
            this.$nextTick(() => this.handleEdit())
          }
        } else {
          this.msgError("查询不到此线索");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    customerChange() {
      this.updateData.contactId = null
      this.loadContactList(this.updateData.customerId)
    },
    loadContactList(customerId) {
      if (!customerId) {
        this.contactList = []
        return
      }
      queryContactByCustomerId({customerId}).then(response => {
        this.contactList = response.data || []
      }).catch(error => {
        this.contactList = []
      })
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value) {
        callback()
      } else if (isPhone(value)) {
        // 填了公司名称，才去校验手机号。所以需要在填写公司名称后再手动触发下手机号校验
        if (this.updateData.companyName) {
          checkCluePhoneNum(
            {
              clueId: this.detail.id,
              informantMobile: value,
              companyName: this.updateData.companyName
            }
          ).then( response => {
            if (response.data && response.data.id) {
              callback(new Error(response.data.id + '#error#' + response.data.informantName))
            } else {
              callback()
            }
          }).catch(error => {
            callback()
          })
        } else {
          callback()
        }
      } else {
        callback(new Error('格式不正确'))
      }
    },
    handleCompanyChange(companyName, companyId) {
      this.updateData.companyId = companyId ? companyId : ''
      this.$refs['updateForm'].validateField('informantMobile')
    },
    toDetailBlank(id) {
      this.$router.push("/crm/clue/detail/" + id);
    },
    skipCustomerDetail(id) {
      this.$router.push("/crm/customer/detail/" + id);
    },
    skipContactDetail(id) {
      this.$router.push("/crm/contact/detail/" + id);
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleEdit () {
      this.updateData.id = this.detail.id
      this.updateData.clueSource = this.detail.clueSource
      this.updateData.customerId = this.detail.customerId
      this.updateData.contactId = this.detail.contactId
      this.updateData.assignUserId = this.detail.managerId
      this.updateData.remark = this.detail.remark
      this.updateData.purchaseIntentionList = this.detail.purchaseIntentionList
      this.editModel = true
      this.customerList = [{id: this.detail.customerId, customerName: this.detail.customerName}]
      this.loadContactList(this.updateData.customerId)
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          updateClue(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("保存成功");
          }).catch(error => {
            loading.close();
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("clue", this.detail.id)
    },
    /** 转商机按钮操作 */
    handleClueToBusiness() {
      this.$refs.clueToBusinessDialogRef.open(this.detail.id);
    },
    /** 关闭按钮操作 */
    handleCloseClue() {
      this.$refs.closeClueDialogRef.open(this.detail.id, this.detail.informantName);
    },
    /** 恢复按钮操作 */
    handleOpenClue() {
      this.$refs.openClueDialogRef.open(this.detail.id, this.detail.informantName);
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    },
    queryMobile(){
      const loading = this.$loading({lock: true, text: '查询中', spinner: 'el-icon-loading'});
      queryMobile({
        id: this.detail.contactId
      }).then(response => {
        if (response.data) {
          this.detail.contactMobile = response.data
        }
      }).finally(error => {
        loading.close()
      })
    }
  }
};
</script>
